export default __webpack_public_path__ + "static/media/Slide47.5c451da8.PNG";